import { AboutContent } from '../../domain/entities/AboutContent.entity';
import { InvalidAboutContentError } from '../../domain/errors/InvalidAboutContentError';
import type { AboutContentSource } from '../../domain/repositories/AboutContentSource.interface';
import type { AboutContentDto } from '../dto/AboutContentDto';
import { ApplicationError, type Logger } from '@dma/shared';

export class GetAboutContentUseCase {
  constructor(
    private readonly contentSource: AboutContentSource,
    private readonly logger: Logger
  ) {}

  public async execute(): Promise<AboutContentDto> {
    const raw = await this.contentSource.getAboutContent();
    try {
      const content = AboutContent.create(raw);
      return content.props;
    } catch (error) {
      if (error instanceof InvalidAboutContentError) {
        this.logger.error('About content failed domain validation', {
          code: error.code,
          message: error.message
        });
        throw new ApplicationError(
          'ABOUT_CONTENT_UNAVAILABLE',
          'محتوای صفحه‌ی درباره‌ی ما در حال حاضر در دسترس نیست.',
          { cause: error }
        );
      }
      throw error;
    }
  }
}
